import React from 'react';
import {IconButton, TextField, Toolbar, Tooltip, Typography} from '@material-ui/core';
import {
    AddBox,
    AddCircleOutlineOutlined,
    Adjust,
    DeleteForeverRounded,
    PlayCircleFilledOutlined,
    StopRounded
} from '@material-ui/icons'
import DownloadAllIcon from "@material-ui/icons/CloudDownloadTwoTone";
import EmailIcon from "@material-ui/icons/ContactMail";
import {ClearAllTwoTone} from "@mui/icons-material";

export function WaiversToolbar(props){
    const {
        newEvaWaiver, isAllowNewEvaWaiver,
        onClientFilter
    } = props;

    return <Toolbar style={{ backgroundColor: '#eee', boxShadow: '3px 3px #ccc', borderRadius: '3px' }}>
    <Typography variant="h6" color="primary" style={{ marginRight: '30px' }}>CastleGarde Waivers</Typography>

    <TextField label='Filter Clients'
               onChange={e => onClientFilter(e.target.value)}
               variant='outlined' />

    {
        isAllowNewEvaWaiver ?
            <Tooltip title={'New EVA'}><div><IconButton onClick={newEvaWaiver} style={{backgroundColor:'lightblue'}}
            ><AddBox /></IconButton></div></Tooltip>
            : ''
    }
    
</Toolbar>
}